// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"artboard"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 17L3 17M17 3V21M7 3V21M21 7L3 7","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArtboardIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'artboard',
    ref,
    icon: element,
  },
));

ArtboardIcon.displayName = 'ArtboardIcon';

export default ArtboardIcon;
